import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Input, Typography } from "antd";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { elvis } from "../../Utils";

const { Option } = Select;
const { Title } = Typography;

const MachineryForm = props => {
  const [form] = Form.useForm();
  const [functionsTypes, setFunctionsTypes] = useState([]);
  const { t } = useTranslation();
  const isEditMode = props.isEditMode || false;

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  // Load function types
  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/farm/enums/machine-functions")
      .then(({ data }) => {
        setFunctionsTypes(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  // Initialize form with record data
  useEffect(() => {
    if (props.record.asset) {
      form.setFieldsValue({
        age: props.record.asset.age,
        value: props.record.asset.value,
        machineFunction: props.record.asset.machineFunction,
        model: props.record.asset.model,
        material: props.record.asset.material,
        dimension: props.record.asset.dimension,
        capacity: props.record.asset.capacity
      });
    }
  }, [props.record.asset, form]);

  // Reset form when exiting edit mode
  useEffect(() => {
    if (!isEditMode && props.record.asset) {
      form.resetFields();
      form.setFieldsValue({
        age: props.record.asset.age,
        value: props.record.asset.value,
        machineFunction: props.record.asset.machineFunction,
        model: props.record.asset.model,
        material: props.record.asset.material,
        dimension: props.record.asset.dimension,
        capacity: props.record.asset.capacity
      });
    }
  }, [isEditMode, form, props.record.asset]);

  // Handle form changes and notify parent
  const handleFormChange = () => {
    if (!isEditMode) return;

    const values = form.getFieldsValue();
    const errors = form.getFieldsError();
    const isValid = errors.every(error => !error.errors.length);

    const newAsset = { ...props.record };
    newAsset.asset.age = elvis(values.age);
    newAsset.asset.value = elvis(values.value);
    newAsset.asset.machineFunction = elvis(values.machineFunction);
    newAsset.asset.model = elvis(values.model);
    newAsset.asset.material = elvis(values.material);
    newAsset.asset.dimension = elvis(values.dimension);
    newAsset.asset.capacity = elvis(values.capacity);
    newAsset.valid = isValid;
    props.parentCallback(newAsset);
  };

  return (
    <Form
      form={form}
      {...formItemLayout}
      className="details_form"
      onValuesChange={handleFormChange}
      onFieldsChange={handleFormChange}
    >
      <Title
        className="details_form_header"
        title="Asset details"
        subTitle="Machinery"
      />

      <Form.Item
        label="Age"
        name="age"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Value (€)"
        name="value"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Model"
        name="model"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Input disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Material"
        name="material"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Input disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Dimension (mc)"
        name="dimension"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Capacity (kg)"
        name="capacity"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <InputNumber disabled={!isEditMode} />
      </Form.Item>

      <Form.Item
        label="Function"
        name="machineFunction"
        rules={isEditMode ? [{ required: false }] : []}
      >
        <Select disabled={!isEditMode}>
          {functionsTypes.map(name => (
            <Option key={name} value={name}>
              {t("farmEnums.machine_function." + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default MachineryForm;